'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAttachment = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var removeAttachment = exports.removeAttachment = (0, _reduxActions.createAction)(_fileUploadsActionTypes.REMOVE_ATTACHMENT);


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/removeAttachment.js
// module id = 564
// module chunks = 2 3